import type { GoldSetItemStatus } from './model'

export const GOLD_SET_NOTES_MAX_LENGTH = 2000

export const GOLD_SET_PASS_PARAM = 'pass'

export const GOLD_SET_QUERY_KEYS = {
  queue: (pass: number) => ['gold-set', 'queue', pass] as const,
  document: (documentKey: string, pass: number) =>
    ['gold-set', 'documents', documentKey, pass] as const,
  categories: () => ['gold-set', 'categories'] as const,
}

export const GOLD_SET_STATUS_LABELS: Record<GoldSetItemStatus, string> = {
  todo: 'To do',
  done_by_me: 'Done by you',
  done_by_other: 'Done by someone else',
}
